import { render } from "./PetBirthdate.vue?vue&type=template&id=1f7e9de1"
import script from "./PetBirthdate.vue?vue&type=script&lang=js"
export * from "./PetBirthdate.vue?vue&type=script&lang=js"

import "./PetBirthdate.vue?vue&type=style&index=0&id=1f7e9de1&lang=css"

import exportComponent from "/builds/sites/smolke/app-kwispelcoach-com/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__